// extracted by mini-css-extract-plugin
export default {"row":"common-module--row--3e6c8","col":"common-module--col--075bd","link":"common-module--link--9d66a"};